// extracted by mini-css-extract-plugin
export default {"wrapper":"games_wrapper__Pc+3K","page":"games_page__SGeLk","games":"games_games__TEyeK","gameBlock":"games_gameBlock__784vb"};